import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, BENEFITS } from "../data";
import { Reveal, SectionLabel } from "./Reveal";

export const Services = () => {
  return (
    <section
      id="diensten"
      className="relative bg-background py-24 sm:py-32"
      data-testid="services"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <SectionLabel>Onze diensten</SectionLabel>
            <Reveal>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-ink leading-[1.02]">
                Reiniging voor jouw woning of bedrijfspand
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-muted-foreground text-base max-w-sm">
              Wij reinigen gevels, daken, terrassen en meer — altijd met de
              zachte Softwash-methode.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-6 auto-rows-[minmax(220px,auto)] gap-5 lg:gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08} className={s.span}>
              <motion.article
                whileHover={{ y: -6 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`service-${s.id}`}
                className="group relative h-full min-h-[240px] overflow-hidden rounded-3xl border border-border bg-navy-deep"
              >
                <Link
                  to={s.path}
                  aria-label={s.title}
                  data-testid={`service-link-${s.id}`}
                  className="absolute inset-0 z-20"
                />
                <img
                  src={s.image}
                  alt={`${s.title} door SoftPro met de Softwash-methode`}
                  className="absolute inset-0 h-full w-full object-cover opacity-70 transition-[transform,opacity] duration-700 group-hover:scale-105 group-hover:opacity-60"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-deep via-navy-deep/50 to-transparent" />
                <div className="relative z-10 flex h-full flex-col justify-between p-7 sm:p-8">
                  <span className="grid h-12 w-12 place-items-center rounded-2xl bg-white/10 backdrop-blur-md text-teal ring-1 ring-white/15">
                    <s.icon className="h-6 w-6" strokeWidth={2} />
                  </span>
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="font-display text-2xl sm:text-3xl font-bold text-white tracking-tight">
                        {s.title}
                      </h3>
                      <ArrowUpRight className="h-6 w-6 text-teal opacity-0 -translate-x-2 transition-[opacity,transform] duration-400 group-hover:opacity-100 group-hover:translate-x-0" />
                    </div>
                    <p className="mt-3 max-w-md text-sm text-white/70 leading-relaxed">
                      {s.text}
                    </p>
                  </div>
                </div>
              </motion.article>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {BENEFITS.map((b, i) => (
            <Reveal key={b.label} delay={i * 0.05}>
              <div
                data-testid={`benefit-${i}`}
                className="flex items-center gap-3 rounded-2xl border border-border bg-card px-4 py-4"
              >
                <b.icon className="h-5 w-5 shrink-0 text-teal" />
                <span className="text-sm font-medium text-ink leading-tight">
                  {b.label}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
